/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export interface RowType extends Partial<EnrollmentUserType> {
  Errors?: string[];
}

export interface ExcelRowType {
  'First Name': string;
  'Last Name': string;
  Email: string;
  NPI: string;
  Specialty: string;
  'Profession (Degree)': string;
  Network?: string;
  'PCP (Yes/No)'?: string;
  'Medical Group'?: string;
  Status?: 'Success' | 'Fail';
  Errors?: string;
}

export interface EnrollmentOrganizationType {
  id: string;
  name: string;
  code: string;
  user_count: number;
}

export interface MaterialTableInstance {
  onQueryChange: (query?: any) => void;
  dataManager: {
    pageSize: number;
    count: number;
    // ... other properties you might use
  };
}

export const defaultExcelColumns = {
  Email: undefined,
  NPI: undefined,
  'Profession (Degree)': undefined,
  Specialty: undefined,
};

export type EnrollmentUserType = {
  id?: string;
  given_name: string;
  family_name: string;
  email: string;
  npi: string;
  specialty: string;
  network?: string;
  pcp?: string;
  degree: string;
  medical_group?: string;
  credentials_sent_last_at?: string | null;
  last_action_at?: string;
  last_actor_email?: string;
};

export type credentialResultType = Record<string, { success: boolean; errors: string[] }>;

export interface EnrollmentStateType {
  selectedUser?: EnrollmentUserType | undefined;
  sendingCredentials: boolean;
  updatingUserState: boolean;
  // bult edit state
  isBulkEditing: boolean;
  bulkEditFileName: string;
  bulkEditReport: ExcelRowType[];
  bulkUploadCount: number;
  targetedOrgId?: string;
}

export type TUserToAdd = {
  firstName: string;
  lastName: string;
  email: string;
  npi?: number;
  degree?: string;
  specialty?: string;
  network?: string;
  pcp?: string;
  medical_group?: string;
};

export interface EditableField {
  field: keyof EnrollmentUserType;
  value: string;
}

export interface EditingRow {
  rowIndex: number;
  fields: EditableField[];
  editingCell: keyof EnrollmentUserType;
  value: string;
}

export type NonEditableFieldCellProps = {
  field: keyof EnrollmentUserType;
  rowIndex: number;
  rowData: any;
  value: any;
};

export type EditableFieldCellProps = {
  rowIndex: number;
  field: keyof EnrollmentUserType;
  rowData: any;
};

export type Direction = 'forward' | 'backward';
